import { DashboardItem } from '../models/DashboardItem';

export function isItemBlocked(item: DashboardItem): boolean {
  return item && item.resizeEnabled === false && item.dragEnabled === false;
}
